import PropTypes from 'prop-types';
import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useTranslation } from 'react-i18next';

export const ModalReassignPatients = ({
    onCancel,
    onConfirmReassign, 
    practitioners, 
    assignedPatientCount, 
    title,
    description
}) => {
    const { t } = useTranslation();
    const [selectedNewPractitionerId, setSelectedNewPractitionerId] = useState(''); // Estado para la selección del nuevo profesional

    const handleConfirm = () => {
        onConfirmReassign(selectedNewPractitionerId || null);
    };

    const confirmButtonText = assignedPatientCount > 0 ? t("Reasignar y Eliminar") : t("Eliminar Profesional");
    const confirmButtonDisabled = assignedPatientCount > 0 && !selectedNewPractitionerId; // Deshabilita si hay pacientes pero no se eligió un profesional

    return (
        <SweetAlert
            warning 
            title={title}
            onConfirm={handleConfirm}
            onCancel={onCancel}
            confirmBtnBsStyle="primary" 
            cancelBtnBsStyle="secondary" 
            confirmBtnText={confirmButtonText}
            cancelBtnText={t("buttons.cancel")} 
            showCancel
            disabled={confirmButtonDisabled} 
        >
            <p>{description}</p>
            {assignedPatientCount > 0 && (
                <p>{t("protocols.groups.willReasign")} **{assignedPatientCount}** {t("protocols.groups.patients")}.</p>
            )}
            <div className="form-group my-3"> 
                <label htmlFor="newPractitionerSelect" className="form-label">{t("protocols.groups.newPractitioner")}:</label>
                <select
                    id="newPractitionerSelect"
                    className="form-control" 
                    value={selectedNewPractitionerId}
                    onChange={(e) => setSelectedNewPractitionerId(e.target.value)}
                >
                    <option value="">{t("protocols.groups.noReasgin")}</option> 
                    {(practitioners || [])
                        .filter((p) => p != null && p.practitionerId != null)
                        .map((p) => {
                            const label =
                                p.practitioner?.fullName ??
                                p.practitioner?.fullNameUnique ??
                                String(p.practitionerId);
                            return (
                                <option key={p.practitionerId} value={p.practitionerId}>
                                    {label}
                                </option>
                            );
                        })}
                </select>
            </div>
        </SweetAlert>
    );
};

ModalReassignPatients.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirmReassign: PropTypes.func.isRequired,
    practitioners: PropTypes.array.isRequired,
    assignedPatientCount: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};